import React from "react";
import { Space, Table } from "antd";
import { ManualStockEntryStockType } from "services/BillingEngineService/interfaces/entities/ManualStockEntry";
import { FacilityOption } from "components/FacilitiesSelect/FacilitiesSelect";
import moment from "moment";
import useQueryStockEntries from "../Api/useQueryStockEntries";
import { TablePaginationConfig } from "antd/lib/table";

const columns = [
  {
    title: "Organization",
    width: "30%",
    dataIndex: ["organization", "name"],
    sorter: (a: any, b: any) => {
      return a.organization.name.localeCompare(b.organization.name);
    },
  },
  {
    title: "Last Updated",
    dataIndex: "date",
    width: "20%",
    render: (dateString: string) => moment.utc(dateString).format("MMMM D, YYYY"),
  },
  {
    title: "Stock",
    dataIndex: "stockAmount",
    width: "15%",
    render: (amount: number) => `${amount || 0}`,
  },
  {
    title: "Notes",
    dataIndex: "notes",
  },
];

interface StockTable {
  selectedStockType?: ManualStockEntryStockType;
  selectedFacility?: FacilityOption;
}

const PAGE_SIZE = 10;

function StockTable({ selectedFacility, selectedStockType }: StockTable) {
  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(PAGE_SIZE);

  const { status, resolvedData } = useQueryStockEntries({
    facilityCode: selectedFacility?.code,
    stockType: selectedStockType,
    page: page,
    limit: PAGE_SIZE,
  });

  const handleTableChange = (pagination: TablePaginationConfig) => {
    const pageUpdate = pagination.current || page;
    const pageSizeUpdate = pagination.pageSize || pageSize;
    setPage(pageUpdate);
    setPageSize(pageSizeUpdate);
  };

  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <Table
        loading={status === "loading"}
        rowKey={(row) => row.id}
        columns={columns}
        dataSource={resolvedData?.data || []}
        onChange={handleTableChange}
        pagination={{
          current: page,
          pageSize: pageSize,
          total: resolvedData?.meta.data.total,
        }}
      />
    </Space>
  );
}

export default StockTable;
